// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__25ABV","link":"style_link__3vOKp","active":"style_active__L5ass"};